<template>
  <b-modal :id="modalId" size="md">
    <template #modal-header>
      Error, Invalidate Body
    </template>

    <template #default>
      Your Mock response body content has invalid format
    </template>

    <template #modal-footer>
      <b-button variant="primary" size="md" @click="closeModal">
        <i class="far fa-times-circle"></i> OK
      </b-button>
    </template>
  </b-modal>
</template>

<script>

  export default {
    props: {
      modalId: {
        type: String,
        default: 'modal-invalided-mock'
      }
    },
    data() {
      return {
        errors: []
      };
    },
    methods: {
      showModal(errors) {
        this.errors = errors;
        this.$bvModal.show(this.modalId)
      },
      closeModal() {
        this.$bvModal.hide(this.modalId)
      },
    }
  };
</script>
